const onboardingComplete = (completed) => ({
  type: 'ONBOARDING_COMPLETE',
  completed,
});

export {
  onboardingComplete,
};
